/// <amd-module name="DistributedTaskUI/Resources/ResourcesStore" />
import { ViewType } from "Constants";
import { ResourcesActionsHub } from "ResourcesActionsHub";
import { IResourcesHubState, ResourceItemExtended, ResourcesHubDataExtended } from "ResourcesHub.Model";

import { CheckIssue, ResourceCheckIssue } from "Checks/Client/Contracts/PipelinesChecks";
import { ResourceItem } from "DistributedTask/Client/Contracts/TaskAgent";
import * as VSSStore from "VSS/Reflux/Store";

export class ResourcesStore extends VSSStore.Store {
    constructor(actionsHub: ResourcesActionsHub) {
        super("resources-hub-store");
        this._initializedState();
        this._actions = actionsHub;
        this._actions.initializeResources.addListener(this._initializeResources);
        this._actions.applyFilters.addListener(this._initializeResources);
        this._actions.fetchNextPage.addListener(this._appendResources);
    }

    public getState(): IResourcesHubState {
        return this._state;
    }

    private _initializedState() {
        this._state = {
            resources: [],
            dataLoaded: false,
            filters: null,
            currentState: "",
            filterBarVisibility: true,
            filterOptions: null,
            viewType: ViewType.Hub,
            selectedResourceIndex: -1,
            continuationToken: "",
            hasProjectLevelManagePermission: true
        };
    }

    private _initializeResources = (data: ResourcesHubDataExtended) => {
        if (data) {
            this._state.resources = this._getResourcesWithIssues(data);
            this._state.filters = data.resourceFilters;
            this._state.filterOptions = data.resourceFilterOptions;
            this._state.filterBarVisibility = true;
            this._state.dataLoaded = this._state.resources.length > 0 || !!this._state.filters;
            this._state.continuationToken = data.continuationToken;
            this._state.hasProjectLevelManagePermission = data.hasProjectLevelManagePermission;
            this.emitChanged();
        }
    }

    private _appendResources = (data: ResourcesHubDataExtended) => {
        if (data) {
            this._state.resources = this._state.resources.concat(this._getResourcesWithIssues(data));
            this._state.filterBarVisibility = true;
            this._state.filterOptions = data.resourceFilterOptions;
            this._state.continuationToken = data.continuationToken;
            this.emitChanged();
        }
    }

    private _getResourcesWithIssues(data: ResourcesHubDataExtended): ResourceItemExtended[] {
        if (data.resourceIssues && data.resourceIssues.length > 0) {
            let resourceItemsWithIssues: ResourceItemExtended[] = data.resourceItems
                .map((resource: ResourceItem) => {
                    let resourceCheckIssue = data.resourceIssues
                        .find((resourceWithIssues: ResourceCheckIssue) => resourceWithIssues.resource.id === resource.id);
                    let checkIssue: CheckIssue | undefined;
                    if (resourceCheckIssue) {
                        checkIssue = resourceCheckIssue.checkIssue;
                    }
                    return {
                        ...resource,
                        issue: checkIssue
                    };
                });

            return resourceItemsWithIssues;
        }
        return data.resourceItems;
    }

    private _state: IResourcesHubState;
    private _actions: ResourcesActionsHub;
}
